import { Link } from "react-router-dom";
import HeaderBG from '../../assets/images/hear-bg.png'

export default function Header(){
    return(
        <section className="header">
            <div className="left">
                <div className="title">
                    <span className="text-small">i'm</span>
                    <span className="text-name">nasir ahmad</span>
                    <span className="text-des">A creative web developer. I design and build innovative, responsive websites. Let's work together to bring your digital ideas to life. Contact me today!</span>
                </div>
                <div className="buttons">
                    <Link className="btn btn-getaproject btn-icon">Get a Project 
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 16 16"
                            fill="none"
                            width="24"
                            height="24"
                            >
                            <path
                                d="M9.62 3.95312L13.6667 7.99979L9.62 12.0465"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M2.33337 8H13.5534"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>

                    </Link>
                    <Link className="viewprojects">
                        view projects   
                    </Link>
                </div>
                <div className="numberof-wrapper">
                    <div className="numberof">
                        <div className="years">
                            <div className="num"><span>+</span>7</div>
                            <div className="text">Years of <br />Experience </div>
                        </div>
                        <div className="dash"></div>
                        <div className="projects">
                            <div className="num"><span>+</span>100</div>
                            <div className="text">Project  <br />Completed</div>
                        </div>
                        <div className="dash"></div>
                        <div className="clients">
                            <div className="num"><span>+</span>245</div>
                            <div className="text">Happy <br />Client</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="right">
                <img src={HeaderBG} alt={'Header Background'} />
                <ul className="social-links">
                    <li className="telegram">
                        <a href="#">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                width="24"
                                height="24"
                                >
                                <path d="M20.665 3.71682L2.93497 10.5538C1.72497 11.0398 1.73197 11.7148 2.71297 12.0158L7.26497 13.4358L17.797 6.79082C18.295 6.48782 18.75 6.65082 18.376 6.98282L9.84297 14.6838H9.84097L9.84297 14.6848L9.52897 19.3768C9.98897 19.3768 10.192 19.1658 10.45 18.9168L12.661 16.7668L17.26 20.1638C18.108 20.6308 18.717 20.3908 18.928 19.3788L21.947 5.15082C22.256 3.91182 21.474 3.35082 20.665 3.71682Z" />
                            </svg>
                        </a>
                    </li>
                    <li className="git">
                        <a href="#">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="24"
                                height="24"
                                fill="currentColor"
                                >
                                <path d="M12 0.297607C5.37 0.297607 0 5.66761 0 12.2976C0 17.6376 3.438 22.0976 8.205 23.6976C8.805 23.8076 9.025 23.4476 9.025 23.1376C9.025 22.8576 9.015 22.0676 9.01 21.0476C5.672 21.6976 4.968 19.4476 4.968 19.4476C4.422 18.0676 3.633 17.6976 3.633 17.6976C2.545 16.9676 3.717 16.9826 3.717 16.9826C4.922 17.0676 5.555 18.2276 5.555 18.2276C6.633 20.0276 8.372 19.5176 9.05 19.2076C9.16 18.4276 9.467 17.8976 9.81 17.5976C7.145 17.2976 4.343 16.2376 4.343 11.5976C4.343 10.2776 4.797 9.19761 5.563 8.34761C5.438 8.04761 5.045 6.79761 5.688 5.09761C5.688 5.09761 6.703 4.77761 9.005 6.34761C9.975 6.07761 11.01 5.93761 12.045 5.93261C13.08 5.93761 14.115 6.07761 15.085 6.34761C17.387 4.77761 18.402 5.09761 18.402 5.09761C19.045 6.79761 18.652 8.04761 18.527 8.34761C19.293 9.19761 19.747 10.2776 19.747 11.5976C19.747 16.2526 16.938 17.2926 14.265 17.5876C14.7 17.9676 15.09 18.7076 15.09 19.8576C15.09 21.4876 15.075 22.7476 15.075 23.1376C15.075 23.4476 15.285 23.8176 15.9 23.6976C20.667 22.0876 24 17.6376 24 12.2976C24 5.66761 18.63 0.297607 12 0.297607Z" />
                            </svg>
                        </a>
                    </li>
                    <li className="instagram">
                        <a href="#">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                width="24"
                                height="24"
                                >
                                <path d="M16.725 6.2998C16.125 6.2998 15.675 6.74981 15.675 7.34981C15.675 7.94981 16.125 8.3998 16.725 8.3998C17.325 8.3998 17.775 7.94981 17.775 7.34981C17.775 6.74981 17.325 6.2998 16.725 6.2998Z" />
                                <path d="M12 7.65039C9.52501 7.65039 7.57501 9.67539 7.57501 12.0754C7.57501 14.4754 9.60001 16.5004 12 16.5004C14.4 16.5004 16.425 14.4754 16.425 12.0754C16.425 9.67539 14.475 7.65039 12 7.65039ZM12 14.9254C10.425 14.9254 9.15001 13.6504 9.15001 12.0754C9.15001 10.5004 10.425 9.22539 12 9.22539C13.575 9.22539 14.85 10.5004 14.85 12.0754C14.85 13.6504 13.575 14.9254 12 14.9254Z" />
                                <path d="M15.6 3H8.475C5.4 3 3 5.4 3 8.4V15.525C3 18.525 5.4 20.925 8.4 20.925H15.525C18.525 20.925 20.925 18.525 20.925 15.525V8.4C21 5.4 18.6 3 15.6 3ZM19.275 15.6C19.275 17.625 17.625 19.35 15.525 19.35H8.4C6.375 19.35 4.65 17.7 4.65 15.6V8.475C4.65 6.45 6.3 4.725 8.4 4.725H15.525C17.55 4.725 19.275 6.375 19.275 8.475V15.6Z" />
                            </svg>
                        </a>
                    </li>
                    <li className="linkedin">
                        <a href="#">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="24"
                                height="24"
                                fill="currentColor"
                                >
                                <g clipPath="url(#clip0)">
                                    <path d="M3.00001 21.6004H6.60001V8.28039H3.00001V21.6004ZM4.80001 2.40039C3.60001 2.40039 2.64001 3.36039 2.64001 4.56039C2.64001 5.76039 3.60001 6.72039 4.80001 6.72039C6.00001 6.72039 6.96001 5.76039 6.96001 4.56039C6.96001 3.36039 6.00001 2.40039 4.80001 2.40039ZM12.72 10.3204V8.28039H9.12001V21.6004H12.72V14.7604C12.72 10.9204 17.64 10.6804 17.64 14.7604V21.6004H21.24V13.4404C21.24 6.96039 14.4 7.20039 12.72 10.3204Z" />
                                </g>
                                <defs>
                                    <clipPath id="clip0">
                                    <rect width="24" height="24" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </a>
                    </li>
                </ul>
            </div>
        </section>
    )
}